import styled from "@emotion/styled";

export const Divider = styled("div")(() => ({
  width: "100%",
  height: 0,
  borderTop: "1px solid rgba(0,0,0,.6)",
  margin: "2rem 0",
}));
